import { atomWithReset } from 'jotai/utils';
import { ChatCFCountSocketPayload, SampleValuesFamilyType, TemplateAtom, TemplateStatus } from '../typings/template';
import { atom } from 'jotai';

export const templateAtom = atomWithReset<TemplateAtom>({
  status: TemplateStatus.ALL,
});

export const sampleValuesAtom = atomWithReset<SampleValuesFamilyType[]>([]);

export const autoRetrySettingsModalVisibleAtom = atom<boolean>(false);

export const selectedBroadcastIdAtom = atom<string | undefined>(undefined);

export const broadcastGroupCFCountUpdateAtom = atom<ChatCFCountSocketPayload | null>(null);
